<template>
  <IconoirProvider>
    <v-app>
      <v-overlay v-if="isLoadingData" v-model="overlay" opacity="1" scrim="rgba(255, 255, 255, 1)">
        <template #default>
          <v-container
            fluid
            class="loader-container d-flex flex-column align-center justify-center text-center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
            width="6"
          />
          <h2 class="mt-6">Cargando...</h2>
          <p class="text-medium-emphasis">
            Espere un momento mientras preparamos todo para ti.
          </p>
        </v-container>
        </template>
      </v-overlay>
      <div v-else>
        <router-view></router-view>
      </div>
    </v-app>
  </IconoirProvider>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import { IconoirProvider } from "@iconoir/vue";
import { storeToRefs } from "pinia";

export default {
  name: "App",
  components: {
    IconoirProvider,
  },
  data() {
    return {
      overlay: true,
    };
  },
  setup() {
    const authStore = useAuthStore();
    const { isAuthenticated, isLoadingData } = storeToRefs(authStore);
    return { authStore, isAuthenticated, isLoadingData };
  },
};
</script>
<style>
html {
  overflow-y: auto !important;
}
.loader-container {
  height: 100vh!important;
  width: 100vw!important;
}
</style>
